import { useContext } from "react";
import { ModalDialogContext } from "../providers";

export function useModalDialogContext() {
  return useContext(ModalDialogContext);
}
